<!--
 * @Autor        : sandyWqh
 * @Date         : 2023-01-13 16:58:46
 * @Description  : 
 * @Version      : 1.0
 * @LastEditors  : sandyWqh
 * @LastEditTime : 2023-01-31 17:14:28
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    if (this._isMobile()) {
      window.location = "http://m.araypower.com";
    }
    if (this.$route.path == "/homepower") {
      document.title = `${this.$t("langs.homepower")} | ${this.$t(
        "langs.sitetitle")}`;
    }
  },
  methods: {
    //判断手机端还是PC端
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/App.vue